export const getReservaCentralizadaDetalleQueryOData = {
  // IMPORTANTE: la indentación del template viaja en la URL (%20%20...) y este query
  // roza el límite de IIS (maxQueryString = 2048); se compacta todo el whitespace
  select: `$expand=PlanPagos($select=TotalUsd,TotalLocal,TotalUsdRedondeado,TotalLocalRedondeado;$expand=PlanPagosDetalle($filter=Habilitado eq true;$select=MontoUsd,MontoLocal,MontoUsdRedondeado,MontoLocalRedondeado)),EstadoFisicoReserva($expand=EstadoLogicoHorizontalReserva($select=EstadoLogicoReservaId,ColorEstadoLogico);$select=EstadoFisicoReservaId,Nombre),
    ConfiguracionReserva($expand=NivelCodigoConfirmacion($select=ListaSeleccionId,Nombre,Valor);
    $select=ConfiguracionReservaId,Nombre,NivelCodigoConfirmacion),Proveedor($select=NombreCompleto;$expand=ConvenioPago($select=Valor)),
    ActividadMaestra($select=ActividadMaestraId,NombreGrupo;$expand=EjecutivoComercial($select=NombreCompleto),
    Cliente($select=Nombre),Estado($select=Nombre),SalesProfit($select=Nombre,Valor)),
    ReservaCentralizadaDetalle($expand=Actividad($expand=Estado($select=EstadoId,Nombre),Producto($select=Nombre,Acomodacion),
    Idioma($select=Nombre),Componente($select=Nombre,Descripcion;$expand=ComponentType($select=Nombre),Feature($select=Nombre)),
    Comentario($expand=TipoComentario($select=Nombre,Valor);$select=TipoComentario,TipoComentarioId,Comentario1);
    $select=ActividadId,TotalFinal,Nombre,CantidadAdulto,CantidadNino,CantidadInfante,Cantidad,CantidadHabitacion,
    TotalPasajeros,Comentario,Acuerdo),EstadoFisicoReserva($select=EstadoFisicoReservaId,Nombre);
    $select=ReservaCentralizadaId,ReservaOldDetalleId,ReservaCentralizadaDetalleId,ActividadId,
    FechaInicio,FechaFin,FechaCreacion,EstadoFisicoReservaId,CantidadAdulto,CantidadNino,CantidadInfante,
    Cantidad,TotalPasajeros,CostoEstandarUsd,CostoEstandarLocal,CostoPactadoUsd,CostoPactadoLocal,
    CostoEstandarUsdRedondeado,CostoEstandarLocalRedondeado,CostoPactadoUsdRedondeado,CostoPactadoLocalRedondeado,
    CodigoConfirmacion,Comentario)&$select=ReservaCentralizadaId,ConfiguracionReservaId,ReservaOldId,
    ProveedorId,ActividadMaestraId,EstadoFisicoReservaId,CodigoConfirmacion,FechaInicio,FechaFin,
    FechaUltimaSolicitudSalesforce,CodigoReserva`.replace(/\s*\n\s*/g, ''),
  filter: `&$filter=ReservaCentralizadaId eq `,
}

export const getPlanPagoQueryOData = `&$filter=ReservaCentralizadaId eq {ID}`

// El .trim() NO es cosmético: sin él la indentación del template viaja en la URL y el parser la
// percent-codifica, así que la PRIMERA opción pasa a llamarse "  $filter" (o "  $select"). Al no
// empezar por $, OData la toma como opción personalizada y la descarta EN SILENCIO; las que van
// tras un & quedan intactas. Es el mismo motivo del .replace() de arriba.
export const getPlanPagoTableQueryOData = `
  $select=PlanPagosId,Pospago,MontoUSD,MontoLocal,MontoUsdRedondeado,MontoLocalRedondeado,Fecha,Porcentaje,PlanPagosDetalleId,Habilitado,EstadoId,ProformaUrl,ProformaNombreArchivo,ProformaFechaCarga,ProformaUsuarioCarga&$expand=Estado($select=Nombre),OrdenPagoDetalle($select=OrdenPagoDetalleId;$expand=OrdenPago($select=CodigoTransaccion))&$filter=PlanPagosId eq {ID}
`.trim()

export const getEstadoByIdQueryOData = `
   $filter=Ambito eq 'PlanPago' and (contains(Nombre, 'Pendiente') or contains(Nombre, 'Cancelado'))&$select=EstadoId,Nombre
`.trim()

export const getNombreArchivoCartaReservaQueryOData = `
  $filter=ReservaCentralizadaId eq {ID}&$expand=ConfiguracionReserva($select=ConfiguracionReservaId,CartaNuevaReserva,CartaModificacionReserva,CartaCancelacionReserva,CartaRoomingListReserva)&$select=ReservaCentralizadaId
`.trim()

export const getEstadosFisicosPaxQueryOData = `
  $filter=DiagramaEstadoReservaId eq {ID}
`.trim()

export const getConfiguracionReservaQueryOData = `
  $select=DiagramaEstadoReservaId,DiagramaEstadoReservaDetalleId&$filter=MenuReservaId eq {ID}&$top=1
`.trim()
